<script>
    import { onMount } from 'svelte';
    import { slide } from 'svelte/transition';
    import { logoutOneUser } from '/public/services/User.js';
    import { navigateTo } from 'svelte-router-spa';

    let processing = true;

    function logoutUser() {
        logoutOneUser().then(res => {
            if (res.success) {
                processing = false;

                setTimeout(gotoHome, 2500);
            }
        });
    }

    function gotoHome() {
        navigateTo('/');
    }

    onMount(() => {
        logoutUser();
    });
</script>
<div class='row justify-content-center mt-5 mb-5'>
    <div class='col-sm-12 col-md-8 col-lg-6'>

        {#if processing === true}

            <div class='card' in:slide>
                <div class='card-body text-center'>
                    <h4 class='m-0'>
                        <span class='ajax-ball-loader'></span> Logging you out of the app....
                    </h4>
                </div>
            </div>

        {:else}

            <div class='alert alert-success clearfix' in:slide>
                <h4 class='float-start me-3'>
                    <span class='fas fa-check-circle'></span>
                </h4>
                You have been successfully logged out.
            </div>

        {/if}

    </div>
</div>